<!-- ------------------Page Heading Start------------- -->

<div class="page_heading">
    <div class="container">
        <h2>Payment Partners</h2>
    </div>
</div>

<!-- ------------------Page Heading End------------- -->

<!-- -------------------------Payment Section Start----------------- -->

<section class="payment_holder rs-section pay" rsParallax>
    <div class="rs-deco" aria-hidden="true">
        <span class="rs-blob rs-blob--purple rs-blob--tl"></span>
        <span class="rs-blob rs-blob--pink rs-blob--br"></span>
        <span class="rs-dots rs-dots--a"></span>
        <span class="rs-dots rs-dots--pink rs-dots--b"></span>
        <span class="rs-ring rs-ring--b"></span>
        <span class="rs-spark" style="--sx: 14%; --sy: 30%; --sd: 0.5s"></span>
        <span class="rs-spark" style="--sx: 84%; --sy: 64%; --sd: 2.1s"></span>
    </div>

    <div class="container rs-shell">
        <header class="rs-head--center pay__head" rsReveal="up">
            <span class="rs-eyebrow rs-eyebrow--barred rs-eyebrow--center">Secure checkout</span>
            <h2 class="rs-title">Pay with <span class="rs-title-grad">confidence</span></h2>
            <p class="rs-lede rs-lede--center">
                Choose a gateway and complete your payment on their encrypted infrastructure —
                we never store your card details.
            </p>
        </header>

        <div class="payment_card pay__card" rsReveal="up" rsRevealDelay="0.08">
            <span class="pay__card-shine" aria-hidden="true"></span>
            <form>
                <p class="pay__legend">Select a payment partner</p>
                <div class="payment_option row pay__options">
                    <div class="payment_item col pay__option">
                        <input id="radio-1" [ngClass]="{ active: this.activeBar === 'stripe' }"
                            (click)="changeTab('stripe');" class="radio-custom" name="radio-group" type="radio" />
                        <label for="radio-1" class="radio-custom-label"><img loading="lazy" src="assets/images/stripe.png" alt="strip" /></label>
                    </div>

                    <div class="payment_item col pay__option">
                        <input id="radio-2" [ngClass]="{ active: this.activeBar === 'razorpay' }"
                            (click)="changeTab('razorpay');" class="radio-custom" name="radio-group" type="radio" />
                        <label for="radio-2" class="radio-custom-label"><img loading="lazy" src="assets/images/razorpay.png" alt="razorpay" /></label>
                    </div>
                    <!-- <div class="payment_item">
                        <input id="radio-3" [ngClass]="{ active: this.activeBar === 'instamojo' }"
                            (click)="changeTab('instamojo');" class="radio-custom" name="radio-group" type="radio" />
                        <label for="radio-3" class="radio-custom-label"><img loading="lazy"
                                src="assets/images/instamojo.png" /></label>
                    </div> -->
                </div>

                <!-- -------------------------ByDefaultform-------------------------------- -->
                <div class="tab-pane" *ngIf="this.activeBar === 'bydefoult'">
                    <div class="payment_fields">
                    <div class="bydefoult_payment">
                        <img loading="lazy" src="assets/images/payment-hold.png" alt="payment-hold">
                        <p class="payment_option_txt">Select Payment Option</p>
                    </div>

                    </div>
                </div>
              <!-- -------------------------EndByDefaultform-------------------------------- -->

              <!-- ------------------------------razorpayForm--------------------------------------->

                <div [formGroup]="razorpayform" class="tab-pane" *ngIf="this.activeBar === 'razorpay'">
                    <div class="payment_form mb-3">
                        <div class="payment_logo"><img loading="lazy" src="assets/images/razorpay.png" alt="razorpay"/></div>
                    </div>


                    <div class="payment_fields">
                        <div class="row pay__row">
                            <div class="col-sm-12 pay__col">
                                <div class="form-group">
                                    <label for="name">Full Name</label>
                                    <input type="text" formControlName="name" class="form-control user_icon" id="name" />
                                    <div id="formError" class="rs-error" *ngIf="Rname && Rname.invalid && Rname.touched">
                                        <span *ngIf="Rname.errors?.['required']">
                                            <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Required
                                        </span>
                                        <span *ngIf="Rname.errors?.['pattern'] && !Rname.errors?.['required']">
                                            <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Invalid Name input </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row pay__row">
                            <div class="col-sm-12 pay__col">
                                <div class="form-group">
                                    <label for="email">Email</label>
                                    <input type="email" formControlName="mail" class="form-control mail_icon" id="email" />
                                    <div id="formError" class="rs-error" *ngIf="Rmail && Rmail.invalid && Rmail.touched ">
                                        <span *ngIf="Rmail.errors?.['required']">
                                            <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Required
                                        </span>
                                        <span *ngIf="Rmail.errors?.['pattern'] && !Rmail.errors?.['required']">
                                            <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Invalid Email Id </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row pay__row">
                            <div class="col-sm-12 pay__col">
                                <div class="form-group">
                                    <label for="num">phone</label>
                                    <input type="tel" formControlName="phone" class="form-control user_icon" id="num" (keypress)="preventNonNumeric($event)"/>
                                    <div id="formError" class="rs-error" *ngIf="Rphone && Rphone.invalid && Rphone.touched ">
                                        <span *ngIf="Rphone.errors?.['required']">
                                            <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Required
                                        </span>
                                        <span *ngIf="razorpayform.get('phone')?.errors?.['minlength']">
                                            <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Enter 10 digit number
                                          </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row pay__row pay__row--split">
                            <div class="col-sm-6 pay__col">
                                <div class="form-group">
                                    <label for="Currency">Currency</label>
                                    <select formControlName="currency" id="Currency">
                                        <option value="INR">INR</option>
                                        <option value="USD">USD</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-sm-6 pay__col">
                                <div class="form-group">
                                    <label for="r-amount">Amount</label>
                                    <input type="tel" id="r-amount" formControlName="price" class="form-control cash_icon" placeholder="0.00" (keypress)="preventNonNumeric($event)"/>
                                    <div id="formError" class="rs-error" *ngIf="Rprice && Rprice.invalid && Rprice.touched ">
                                        <span *ngIf="Rprice.errors?.['required']">
                                            <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Required
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row pay__row">
                            <div class="col-sm-12 pay__col">
                                <button class="pay rs-btn rs-btn--primary rs-btn--block" rsRipple (click)="pay()">
                                    <span>Pay with Razorpay</span>
                                    <span class="rs-btn__icon" aria-hidden="true">
                                        <svg viewBox="0 0 24 24" fill="none">
                                            <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
<!-- ------------------------------EndrazorpayForm--------------------------------------->

<!-- ------------------------------InstamojoForm--------------------------------------->
                <!-- <div class="tab-pane" *ngIf="this.activeBar === 'instamojo'">
                    <div class="payment_form mb-3">
                        <div class="payment_logo"><img loading="lazy" src="assets/images/instamojo.png" /></div>
                    </div>

                    <div class="payment_fields">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="email">Full Name</label>
                                    <input type="text" class="form-control user_icon" id="name" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="email">Email</label>
                                    <input type="email" class="form-control mail_icon" id="email" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="email">Payment Purpose</label>
                                    <input type="text" class="form-control" id="email" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="email">Currency</label>
                                    <select>
                                        <option>--</option>
                                        <option>USD</option>
                                        <option>INR</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="email">Amount</label>
                                    <input type="email" class="form-control cash_icon" placeholder="0.00" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12">
                                <button class="pay">Pay with Instamojo</button>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- ------------------------------EndInstamojoForm--------------------------------------->

                <!-- ------------------------------stripeForm--------------------------------------->
                <div [formGroup]="stripeform" class="tab-pane" *ngIf="this.activeBar === 'stripe'">
                    <div class="payment_form mb-3">
                        <div class="payment_logo"><img loading="lazy" src="assets/images/stripe.png" alt="stripe"/></div>
                    </div>

                    <div class="payment_fields"  *ngIf="!Stripeisvalid">

                        <div class="row pay__row">
                            <div class="col-sm-12 pay__col">
                                <div class="form-group">
                                    <label for="s-name">Cardholder Name</label>
                                    <input type="text" id="s-name" formControlName="name" class="form-control user_icon" >
                                    <div id="formError" class="rs-error" *ngIf="Sname && Sname.invalid && Sname.touched ">
                                        <span *ngIf="Sname.errors?.['required']">
                                            <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Required
                                        </span>
                                        <span *ngIf="Sname.errors?.['pattern'] && !Sname.errors?.['required']">
                                            <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Invalid Name input </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row pay__row">
                            <div class="col-sm-12 pay__col">
                                <div class="form-group">
                                    <label for="email">Email</label>
                                    <input type="email" formControlName="mail" class="form-control mail_icon" id="email" />
                                    <div id="formError" class="rs-error" *ngIf="Smail && Smail.invalid && Smail.touched ">
                                        <span *ngIf="Smail.errors?.['required']">
                                            <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Required
                                        </span>
                                        <span *ngIf="Smail.errors?.['pattern'] && !Smail.errors?.['required']">
                                            <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Invalid Email Id </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row pay__row pay__row--split">
                            <div class="col-sm-6 pay__col">
                                <div class="form-group">
                                    <label for="s-currency">Currency</label>
                                    <select formControlName="currency" id="s-currency">
                                        <option value="inr">INR</option>
                                        <option value="usd">USD</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-sm-6 pay__col">
                                <div class="form-group">
                                    <label for="amount">Amount</label>
                                    <input type="tel" formControlName="price" class="form-control cash_icon" id="amount"
                                        placeholder="0.00" (keypress)="preventNonNumeric($event)"/>
                                        <div id="formError" class="rs-error" *ngIf="Sprice && Sprice.invalid && Sprice.touched ">
                                            <span *ngIf="Sprice.errors?.['required']">
                                                <i aria-hidden="true" class="fa fa-exclamation-triangle"></i> Required
                                            </span>
                                        </div>
                                </div>
                            </div>
                        </div>

                        <div class="row pay__row">
                            <div class="col-sm-12 pay__col">
                                <!-- [disabled]="stripeform.invalid" -->
                                <button class="pay rs-btn rs-btn--primary rs-btn--block" rsRipple (click)="initializePayment()">
                                    <span>Proceed to pay</span>
                                    <span class="rs-btn__icon" aria-hidden="true">
                                        <svg viewBox="0 0 24 24" fill="none">
                                            <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>

                    </div>
                    <div class="stripe-pay" *ngIf="Stripeisvalid">
                        <form id="payment-form">
                            <div id="payment-element" #paymentelement>
                            <!--Stripe.js injects the Payment Element-->
                            </div>
                            <button type="button" [disabled]="submitdisabled" (click)="handleSubmit($event)" id="submit">
                                <span id="button-text" [class.hidden]="!spinner">Pay now</span>
                            </button>
                            <div id="payment-message" class="hidden"></div>
                        </form>
                    </div>
                </div>

                <!-- ------------------------------EndstripeForm--------------------------------------->
            </form>

            <p class="pay__trust">
                <i class="fa fa-lock" aria-hidden="true"></i>
                256-bit encrypted. Processed by Stripe / Razorpay.
            </p>
        </div>
    </div>
</section>

<!-- -------------------------Payment Section End----------------- -->


<section *ngIf="iswaiting" id="spinnerforpayment">
    <div class="spinnercontainer">
        <div></div>
    </div>
</section>
